//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.DrawShapes.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObjectList.js";
import "../GeometricUtilities/GeometricUtilities.StrokeGestureData.js";
import "../no/DisplayableObject.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CanCreatePrimitives",1,0],[0,"CanDrawOnNearestFace",1,0],[0,"Color",1,0],[0,"DetectionSensitivity",1,0],[0,"OversketchExistingCurves",1,0],[1,"ParallelCurveTargets",0,"SelectDisplayableObjectList",0],[0,"SnapToOption",1,0],[0,"Snapping",1,0],[1,"StrokeGesture",0,"GeometricUtilities.StrokeGestureData",0],[0,"Thickness",1,0]],[[["overSketchTolerance"],"SetOverSketchTolerance",{},1,0]],[]];
SPLM.Features.DrawShapes.DrawCurveData = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.DrawShapes.DrawCurveData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.DrawShapes.DrawCurveData.DetectionSensitivityOption = Object.freeze({
    "Low" : "Low", "Standard" : "Standard", "High" : "High"});

SPLM.Features.DrawShapes.DrawCurveData.SnappingOption = Object.freeze({
    "None" : "None", "CurveEndPoints" : "CurveEndPoints", "IsoparametricGrid" : "IsoparametricGrid"});

SPLM.Features.DrawShapes.DrawCurveData.SnapToOptions = Object.freeze({
    "None" : "None", "Curve" : "Curve", "CurveWithTangent" : "CurveWithTangent", "ParallelCurve" : "ParallelCurve", "IsoparametricGrid" : "IsoparametricGrid"});

export default SPLM;